<template>
  <generic-modal :title="$t('identity verification')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("first name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.first_name"
                :placeholder="$t('first name')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("last name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.last_name"
                :placeholder="$t('last name')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("id number") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.id_number"
                :placeholder="$t('id number')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("email") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.email"
                placeholder="strato0100@gmail.com"
              />
            </div>
          </div>
        </div>
      </div>
      <div id="onfido-mount"></div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, post, generate_error_message_text, get } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "OnfidoRequestModal",
  components: {
    GenericModal,
  },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !(v.meta.first_name && v.meta.last_name && v.meta.id_number);
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    // start() {
    //   let v = this;
    //   let data = { ...v.meta };
    //   put("/onfido/request/init", data)
    //     .then((r) => {
    //       let script_element = document.createElement("script");
    //       script_element.src = r.js_sdk_resource;
    //       script_element.charset = "utf-8";
    //       document.body.appendChild(script_element);

    //       let settings = r.settings;
    //     })
    //     .catch((error) => {
    //       console.log("error", error);
    //       v.error = generate_error_message_text(error);
    //     });
    // },
    save() {
      let v = this;
      let data = { ...v.meta };
      post("/identity/verification", data)
        .then((r) => {
          v.$refs.generic_modal.close_modal();
          v.$emit("success");
        })
        .catch((error) => {
          console.log("error", error);
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
